import { DataObject } from "@/types";

export const MetaData: DataObject =  {
    "pl" : {
        "title": "Załóż konto rzeczywiste - Bezpieczny Dom Maklerski TMS Brokers",
        "metaTitle": "Rachunek maklerski TMS Brokers. Założenie konta zajmie tylko 5 minut.",
        "metaDescription": "Otwórz rachunek inwestycyjny w TMS Brokers i zacznij handel na: walutach, indeksach, akcjach, surowcach, kryptowalutach.",
        "ogUrl": "https://www.tms.pl/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/tms-oanda-logo/tms_oanda_logo.svg"
    },
    "en" : {
        "title": "Open trading account - OANDA",
        "metaTitle": "Open trading account - OANDA",
        "metaDescription": "Open the trading account in 10 minutes and start trading on Forex, Crypto, CFD's and Shares markets.",
        "ogUrl": "https://www.oanda.com/eu-en/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/oanda-logo/oanda.svg"
    },
    "es": {
        "title": "Abrir una cuenta real - Casa de corretaje TMS Brokers",
        "metaTitle": "Cuenta de corretaje TMS Brokers. Solo hacen falta 5 minutos para crear una cuenta.",
        "metaDescription": "Abra una cuenta de inversión con TMS Brokers y comience a operar con divisas, índices, acciones, fondos ETF, materias primas y criptomonedas.",
        "ogUrl": "https://www.oanda.com/eu-es/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/oanda-logo/oanda.svg"
    },
    "lt": {
        "title": "Atidarykite realią sąkaitą - Saugus brokerio namai TMS Brokers",
        "metaTitle": "TMS Brokers tarpininkavimo sąskaita. Paskyros sukūrimas užtruks tik 5 minutes.",
        "metaDescription": "Atidarykite TMS Brokers investicinę sąskaitą ir pradėkite prekybą: valiutomis, indeksais, akcijomis, žaliavomis, kriptovaliutomis.",
        "ogUrl": "https://www.tmsbrokers.com/lt/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/tms-oanda-logo/tms_oanda_logo.svg"
    },
    "lv" : {
        "title": "Izveido reālo kontu - Drošs Brokeru Nams TMS Brokers",
        "metaTitle": "TMS Brokers tirdzniecības konts. Konta reģistrācija aizņems tikai 5 minūtes.",
        "metaDescription": "Atver TMS brokers investīciju kontu un sāc tirdzniecību uz: valūtām, indeksiem, akcijām, ETF fondiem, izejvielām un kriptovalūtām.",
        "ogUrl": "https://www.tmsbrokers.com/lv/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/tms-oanda-logo/tms_oanda_logo.svg"
    },
    "ru": {
        "title": "Открой реальный счёт - Безопасный Брокерский Дом TMS Brokers",
        "metaTitle": "Брокерский счёт TMS Brokers. Регистрация счёта займет всего 5 минут.",
        "metaDescription": "Открой инвестиционный счёт в TMS Brokers и начни торговлю на: валютах, индексах, акциях, фондах ETF, товарах, криптовалютах.",
        "ogUrl": "https://www.tmsbrokers.com/ru/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/tms-oanda-logo/tms_oanda_logo.svg"
    },
    "cz": {
        "title": "Založte si skutečný účet - OANDA TMS Brokers",
        "metaTitle": "Makléřský účet OANDA TMS Brokers. Založení účtu trvá pouhých 5 minut.",
        "metaDescription": "Otevřete si investiční účet v Makléřském domě OANDA TMS Brokers a začněte obchodovat s: měnami, indexy, akciemi, zbožím, kryptoměnami.",
        "ogUrl": "https://www.tmsbrokers.com/cz/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/tms-oanda-logo/tms_oanda_logo.svg"
    },
    "ua" : {
        "title": "Відкрийте реальний рахунок - Безпечний Брокерський дім TMS Brokers",
        "metaTitle": "Брокерський рахунок TMS Brokers. Відкриття рахунку займе лише 5 хвилин.",
        "metaDescription": "Відкрийте інвестиційний рахунок в TMS Brokers i почніть торгівлю на: валютах, індексах, акціях, сировині, криптовалютах.",
        "ogUrl": "https://www.tmsbrokers.com/ua/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/tms-oanda-logo/tms_oanda_logo.svg"
    },
    "fr" : {
        "title": "Ouvrez un compte réel - OANDA",
        "metaTitle": "Compte de courtage OANDA Créer un compte ne prend que 5 minutes.",
        "metaDescription": "Ouvrez un compte d'investissement avec OANDA et commencez à négocier dans des devises, indices, actions, fonds ETF, matières premières et crypto-monnaies.",
        "ogUrl": "https://www.oanda.com/eu-fr/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/oanda-logo/oanda.svg"
    },
    "it" : {
        "title": "Apri un conto reale - OANDA",
        "metaTitle": "Conto di intermediazione OANDA. Ci vogliono solo 5 minuti per aprire un conto.",
        "metaDescription": "Apri un conto di investimento con OANDA e inizia a fare trading su valute, indici, azioni, fondi ETF, materie prime e criptovalute.",
        "ogUrl": "https://www.oanda.com/eu-it/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/oanda-logo/oanda.svg"
    },
    "pt" : {
        "title": "Abrir uma conta real - OANDA",
        "metaTitle": "Conta de corretagem da OANDA. Criar uma conta demora apenas 5 minutos.",
        "metaDescription": "Abra uma conta de investimento com a OANDA e comece a negociar moedas, índices, ações, fundos ETF, matérias-primas e criptomoedas.",
        "ogUrl": "https://www.oanda.com/eu-pt/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/oanda-logo/oanda.svg"
    },
    "de" : {
        "title": "Eröffnen Sie ein reales Konto: OANDA",
        "metaTitle": "OANDA-Wertpapierdepot. Das Anlegen eines Kontos dauert nur 5 Minuten.",
        "metaDescription": "Eröffnen Sie ein Investment-Konto bei OANDA und starten Sie mit dem Trading von Währungen, Indizes, Aktien, ETFs, Rohstoffen und Kryptowährungen.",
        "ogUrl": "https://www.oanda.com/eu-de/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/oanda-logo/oanda.svg"
    },
    "nl" : {
        "title": "Open een echte rekening - OANDA",
        "metaTitle": "OANDA-effectenrekening. Aanmaken van een rekening duurt slechts 5 minuten.",
        "metaDescription": "Open een beleggingsrekening bij OANDA en begin met handelen in valuta's, indices, aandelen, ETF-fondsen, termijngoederen en cryptovaluta's.",
        "ogUrl": "https://www.oanda.com/eu-nl/onboarding/",
        "ogImage": "https://proxy.tms.pl/images/oanda-logo/oanda.svg"
    },
};